"use strict";
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const Container_1 = __importDefault(require("../../../../layouts/Container"));
const ButtonDropdown_1 = __importDefault(require("../../../ButtonDropdown"));
const SettingsPopover = ({ pageSize, pageSizes, settingsId, settingsOpen, disableGroupBy, gotoPage, settingsAnchor, handleSettingsClose, setPageSize, styles, columnsGroupingComponent, columnsSelectorComponent, }) => (react_1.default.createElement(core_1.Popover, { id: settingsId, open: settingsOpen, anchorEl: settingsAnchor, onClose: handleSettingsClose, anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'center',
    }, transformOrigin: {
        vertical: 'top',
        horizontal: 'center',
    } },
    react_1.default.createElement(Container_1.default, { title: "Settings", style: { marginBottom: 0 } },
        react_1.default.createElement(core_1.Grid, { container: true, spacing: 2 },
            react_1.default.createElement(core_1.Grid, { item: true },
                react_1.default.createElement("div", { className: styles.verticalGrid },
                    react_1.default.createElement("b", null, "Page size"),
                    react_1.default.createElement(ButtonDropdown_1.default, { content: pageSize, items: pageSizes.map((pageSize) => {
                            return {
                                text: pageSize,
                                onClick: (e) => {
                                    setPageSize === null || setPageSize === void 0 ? void 0 : setPageSize(Number(e.target.textContent));
                                    gotoPage === null || gotoPage === void 0 ? void 0 : gotoPage(0);
                                },
                            };
                        }) }))),
            disableGroupBy ? null : (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(core_1.Grid, { item: true },
                    react_1.default.createElement(core_1.Divider, { orientation: "vertical" })),
                react_1.default.createElement(core_1.Grid, { item: true }, columnsGroupingComponent))),
            react_1.default.createElement(core_1.Grid, { item: true },
                react_1.default.createElement(core_1.Divider, { orientation: "vertical" })),
            react_1.default.createElement(core_1.Grid, { item: true }, columnsSelectorComponent)))));
exports.default = SettingsPopover;
//# sourceMappingURL=index.js.map